<template>
    <main-content>
        <kt-panel>
            <div class="accordion accordion-toggle-arrow" id="userFilter">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="headingOne">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#filterForm"
                             aria-controls="filterForm">
                            {{ $t('label.search') }}
                        </div>
                    </div>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="action($event, query)" id="'transaction-filter-form'">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col v-if="$can('read', 'transaction')" xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="user_id">
                                                    {{ $t('label.user_id') }}
                                                </kt-form-label>
                                                <kt-form-control ref="user_id" dir="ltr" name="user_id" id="user_id"
                                                                 v-model="query.user_id"/>
                                            </kt-form-group>
                                        </kt-col>

                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="id">
                                                    {{ $t('label.transaction_id') }}
                                                </kt-form-label>
                                                <kt-form-control ref="id" dir="ltr" name="id" id="id"
                                                                 v-model="query.id"/>
                                            </kt-form-group>
                                        </kt-col>

                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="order_id">
                                                    {{ $t('label.order_id') }}
                                                </kt-form-label>
                                                <kt-form-control ref="order_id" dir="ltr" name="order_id"
                                                                 id="order_id" v-model="query.order_id"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="ref_id">
                                                    {{ $t('label.transaction_ref_id') }}
                                                </kt-form-label>
                                                <kt-form-control ref="ref_id" dir="ltr" name="ref_id"
                                                                 id="ref_id" v-model="query.ref_id"
                                                />
                                            </kt-form-group>
                                        </kt-col>

                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="price">
                                                    {{ $t('label.price') }}
                                                </kt-form-label>
                                                <kt-form-control ref="price" name="price" id="price"
                                                                 v-model="query.price"></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>

                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="card_number">
                                                    {{ $t('label.card_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    ref="card_number"
                                                    name="card_number"
                                                    id="card_number"
                                                    style="direction:ltr"
                                                    v-bind:placeholder="$t('label.card_number_sample')"
                                                    v-model="query.card_number"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        type="button"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name="from_date"
                                                    v-model="query.from_date"
                                                    type="datetime"/>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        type="button"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name="to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="ref_num">
                                                    {{ $t('label.ref_num') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    ref="ref_num"
                                                    name="ref_num"
                                                    id="ref_num"
                                                    v-model="query.ref_num"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group>
                                                <kt-form-label for="phone">
                                                    {{ $t('label.phone') }}
                                                </kt-form-label>
                                                <kt-form-control ref="phone" dir="ltr" name="phone"
                                                                 id="phone" v-model="query.phone"
                                                />
                                            </kt-form-group>
                                        </kt-col>

                                        <!-- Psp -->
                                        <kt-col xs="12" sm="6" md="4">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.psp') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="transaction_type" class="form-control"
                                                                name="transaction_type" v-model="query.psp"
                                                >
                                                    <option value=""></option>
                                                    <option
                                                        v-bind:key="index"
                                                        v-for="(psp_type, index) in pspTypes"
                                                        v-bind:value="psp_type.value"
                                                        :selected="query.psp_type === psp_type.value"
                                                    >
                                                        {{ psp_type.name }}
                                                    </option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6">
                                            <input type="submit" id="search_submit" class="btn btn-success btn-wide"
                                                   :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </kt-panel>
        <kt-panel>
            <div class="tab-content">
                <kt-datatable v-bind="datatableProps" ref="pf"></kt-datatable>
            </div>
        </kt-panel>
    </main-content>
</template>

<script>

import MainContent from "@/components/main-content.vue";
import pspRequests from "@/views/gateway/components/psp-requets.vue";
import {ApiUrl, StarShopApiUrl, transactionService} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import excelRequestTable from "@/views/transaction/datatable/excelRequestTable";
import inquiryActions from "@/views/transaction/datatable/inquiry-actions.vue";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";

export default {
    name: "inquiry-transaction",
    components: {pspRequests, MainContent},
    data() {
        return {
            query: {},
            pspTypes: [
                {
                    name: "پرداخت نوین",
                    value: "NOVIN"
                },
                {
                    name: "به پرداخت ملت",
                    value: "Mellat"
                },
                {
                    name: "پارسیان",
                    value: "PARSIAN"
                },
                {
                    name: "پاسارگاد",
                    value: "PASARGAD"
                },
                {
                    name: "سامان",
                    value: "Saman"
                },
                {
                    name: "سپهر",
                    value: "Sepehr"
                },
                {
                    name: "ایران کیش",
                    value: "Irankish"
                },
                {
                    name: "آسان پرداخت",
                    value: "Asanpardakht"
                },
                {
                    name: "صادرات",
                    value: "Saderat"
                },
            ],
            panelTypes: [
                {
                    name: this.$t('label.pardakhtyari'),
                    key: "pf",
                },
                {
                    name: this.$t('label.star_shop'),
                    key: "starshop",
                }
            ],
            url: ApiUrl.path('transaction/excel-request'),
        }
    },

    computed: {
        datatableProps() {
            return {
                id: this.currentTab,
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.url,
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: excelRequestTable,
                actions: inquiryActions,
            }
        },
    },

    methods: {
        action(e) {
            let form = $(e.target)
            let btn = $('#search_submit')
            form.validate({
                ignore: ":hidden",
                rules: {
                    from_date: {
                        required: true
                    },
                    to_date: {
                        required: true
                    },
                    card_number: {
                        required: true
                    },
                }
            })

            if (!form.valid()) {
                return false;
            }

            this.query.panel_type = 'pf';
            KTApp.progress(btn)
            transactionService.requestInquiryTransaction(this.query)
                .then(({data}) => {
                    this.toastr.success(data.data.message)
                  this.$refs.pf.reload()
                }).catch(({response}) => {
                    this.toastr.error(response.data.message)
                form.validate().showErrors(response.data.data)
            }).finally(() => {
                KTApp.unprogress(btn)
            })


        },

        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null
            }
        },
    }
}
</script>

<style scoped>

</style>